<template>
  <div>
    <!-- Page Title -->
    <page-title icon="fa fa-leaf" main="Safras" sub="Culturas" :help="true" titleHelp="Ajuda - Culturas"
      content="Página responsável por listar culturas e seus respectivos ciclos.
Possibilitando criação de ciclos padrões da vegetal ou para um específico cliente
É possível duplicar um ciclo padrão para um cliente ao clicar em novo ciclo de uma cultura e selecionando um ciclo padrão da Vegetal caso exista."></page-title>

    <!-- Page Content -->
    <card>
      <div slot="header" class="row align-items-center">
        <div class="col">
          <h5 class="h3 mb-0">Filtros</h5>
          <h6 class="text-uppercase text-muted ls-1 mb-1">
            Filtros de culturas
          </h6>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-lg md-4">
          <crop-filter-select :crop="crop" @selected="setCrop" />
        </div>
        <div class="col-12 col-md-6 col-lg md-4">
          <crop-filter-wallet :region="region" @selected="setWallet" />
        </div>
        <div class="col-12 col-md-6 col-lg md-4">
          <client-filter-select :client="client" @selected="setClient" />
        </div>
        <div class="col-12 col-md-6 col-lg md-4">
          <label class="form-control-label">Cultura</label>
          <multiselect
            v-model="culture"
            :options="filterCultures"
            placeholder="Selecione uma cultura"
            label="description"
            track-by="id"
            :preserveSearch="true"
            :showNoResults="false"
            :loading="loadingSelectedCultures"
            :internal-search="false"
            @search-change="debouncedLoadSelectCultures"
          />
        </div>
      </div>
      <div slot="footer" class="row justify-content-end mr-1">
        <base-button
          type="secondary"
          class="mr-2 mt-2"
          @click="clearFilters">
          Limpar Filtros
        </base-button>
        <base-button
          type="primary"
          class="mr-2 mt-2"
          @click="onSubmit"><i class="fas fa-filter"></i>
          Filtrar
        </base-button>
      </div>
    </card>

    <div v-loading="isLoading">
      <culture-card 
        v-for="culture in this.cultures" 
        :key="culture.id" 
        :culture="culture" 
        :client="filteredClient"
        :crop="filteredAnosafra"
      />
    </div>
    
    <div class="card-footer py-4 d-flex justify-content-end">
      <base-pagination v-on:input="loadPageCultures" v-model="paginated_data_cultures.current"
        :total="paginated_data_cultures.count" :perPage="paginated_data_cultures.per_page">
      </base-pagination>
    </div>
    
  </div>
  
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import CultureCard from "./CultureCard";
import CropFilterSelect from "@/components/Widgets/Crops/CropFilterSelect";
import CropFilterWallet from "@/components/Widgets/Crops/CropFilterWallet";
import ClientFilterSelect from "@/components/Widgets/Clients/ClientFilterSelect";
import DoughnutChart from "@/components/Charts/DoughnutChart";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import EmptyData from "@/layouts/EmptyData.vue"
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DoughnutChart.name]: DoughnutChart,
    PageTitle,
    CropFilterSelect,
    CropFilterWallet,
    CultureCard,
    ClientFilterSelect,
    Multiselect,
    EmptyData
  },
  data: () => {
    return {
      crop: {},
      salesmans: [],
      region: {},
      regions: [0],
      cultures: [],
      cultureIds: [],
      clientsRegion: [],
      paginated_data_cultures: {
        current: 1,
        count: 0,
        per_page: 10,
      },
      paginated_data: {},
      client: {},
      isLoading: false,
      clients: {},
      modals: {
        cicleForm: false,
      },
      culture: null,
      filteredAnosafra: {},
      filteredCulture: {},
      filteredClient: {},
      filterCultures: [],
      loadingSelectCultures: false,
      selectCulturesTimeout: null,
    };
  },
  mounted() {
    this.loadRegionsClients();
    this.updateNameClient();
    this.updateRegion();
    this.loadSelectCultures();
  },
  methods: {
    clearFilters(){
      this.filteredAnosafra = {}
      this.filteredClient = {}
      this.filteredCulture = {}
      this.client = {}
      this.culture = {}
      this.crop = {}
      this.region = {}

      this.loadPageCultures()
    },
    onSubmit(){
      this.filter()
      this.loadPageCultures()
      this.loadRegionsClients(this.region)
    },
    filter() {
      this.filteredAnosafra = this.crop
      this.filteredClient = this.client
      this.filteredCulture = this.culture
    },
    async getCultureIds() {
      try {
        const response = await this.$http.secured.get("/api/v1/culture_ids", { params : { client_id: this.client.id } })
        this.cultureIds = response.data
      } catch (error) {
        console.log(error)
      }
    },
    async getCultures(params) {
      try {
        const response = await this.$http.secured.get("/api/v1/cultures", {
          params: params
        })

        return response
      } catch (error) {
        console.error("[Cultures][Index] Error: ", error)
      }
    },
    debouncedLoadSelectCultures(description = null) {
      if (this.selectCulturesTimeout) clearTimeout(this.selectCulturesTimeout);

      this.selectCulturesTimeout = setTimeout(async () => { await this.loadSelectCultures(description)}, 500);
    },
    async loadSelectCultures(description = null) {
      const params                 = {}
      if (description) params.q    = { description: description };

      this.loadingSelectCultures = true;
      const response               = await this.getCultures(params)
      this.filterCultures          = response.data.cultures;
      this.loadingSelectCultures = false;
    },
    async loadPageCultures() {
      this.isLoading = true;
      var q = null;

      if (this.validateQueryObject(this.filteredClient))  q = { client_id: this.filteredClient.id };
      if (this.validateQueryObject(this.filteredCulture)) q = { id: this.filteredCulture.id, ...q };

      const response = await this.getCultures({page: this.paginated_data_cultures.current, q: q })

      this.paginated_data_cultures.per_page = response.data.per_page || 10
      this.paginated_data_cultures.count = response.data.count || 0
      this.paginated_data_cultures.current = response.data.current || 1
      this.cultures = response.data.cultures;
      this.isLoading = false;
    },
    validateQueryObject(queryObject) {
      return queryObject != null &&
        typeof queryObject != "undefined" &&
        Object.keys(queryObject).length
    },
    loadRegionsClients(region) {
      this.isLoading = true;

      var q = null;
      if (
        region != null &&
        typeof region != "undefined" &&
        Object.keys(region).length
      )
        q = { region_ids: region.id };

      this.$http.secured
        .get("/api/v1/clients", {
          params: {
            q: q,
          },
        })
        .then((response) => {
          this.paginated_data = response.data["clients"]
            ? response.data["clients"]
            : [];
          this.clientsRegion = this.paginated_data;
          this.$root.$emit("options", this.clientsRegion);
          this.isLoading = false;

        });
    },
    setClient(client) {
      this.client = client;
    },
    setCrop(crop) {
      this.crop = crop;
    },
    setWallet(region) {
      this.region = region;
    },
    updateNameClient: function () {
      let client = this.$route.params.client;
      this.setClient(client);
      return this.loadPageCultures();
    },
    updateRegion: function () {
      let region = this.$route.params.region;
      this.setWallet(region);
      return this.loadRegionsClients(region);
    },
  },
  watch: {
    region(newWallet) {
      this.loadRegionsClients(newWallet);
    },
  },
};
</script>
